import { DomainIdMapping } from '../../models/domain-id-mapping.type';
import { DomainId } from '../../models/domain-id.enum';

export function domainIdFromDomain(
  defaultDomainId: DomainId,
  domainIdMapping?: DomainIdMapping,
  hrefOrUndefined?: string,
): DomainId {
  if (!domainIdMapping) {
    return defaultDomainId;
  }

  const href = hrefOrUndefined ?? window.location.href;
  const url: URL = new URL(href);

  const matchedDomainId: DomainId | undefined = Object.entries(domainIdMapping)
    .map(
      ([domainId, domainPattern]: [string, RegExp | RegExp[] | undefined]) => ({
        domainId: domainId as DomainId,
        domainPattern: Array.isArray(domainPattern)
          ? domainPattern.find((domainPattern: RegExp) =>
              domainPattern.test(url.hostname),
            )
          : domainPattern,
      }),
    )
    .find(({ domainPattern }) => domainPattern?.test(url.hostname))?.domainId;

  return matchedDomainId ?? defaultDomainId;
}
